module.exports = __webpack_public_path__ + "static/media/recorrido10k.2ee0beba.webp";